import React, { createContext, useState, ReactNode } from 'react';

interface EndpointContextType {
    endpointData: any;
    setEndpointData: (data: any) => void;
  
}

export const EndpointContext = createContext<EndpointContextType>({
  endpointData: undefined,
  setEndpointData: () => {}, 
});

interface EndpointProviderProps {
  children: ReactNode;
}

export function EndpointProvider({ children }: EndpointProviderProps) {
  const [endpointData, setEndpointData] = useState<any>();

  const value = {
    endpointData,
    setEndpointData,
  };

  return <EndpointContext.Provider value={value}>{children}</EndpointContext.Provider>;
}
